import { useIntl } from 'react-intl';
import { Page } from '../../../../../../components/page/Page';
import { AodBreadcrumbs } from '../../components/AodBreadcrumbs';
import { AodCreateRuleWizard } from './AodCreateRuleWizard';

export const AodRuleAddPage = () => {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: 'audit.aod.rules.addScreen.title',
    defaultMessage: 'Crear regla AOD',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header title={title} breadcrumbs={<AodBreadcrumbs />} />
      <Page.Content>
        <AodCreateRuleWizard />
      </Page.Content>
    </Page>
  );
};
